// Qué entra a la tabla POS de «Teléfono» (grupo «Nueva venta») y cuándo quedan las últimas piezas.
import type { CatalogItem } from '@/domains/sales/wizard/types';
import { isService } from '@/domains/sales/wizard/catalogAvailability';
import { availableOf } from '../../pos/lib/posCatalog';

/** Hasta cuántas piezas cuenta como «Últimas piezas». */
export const LAST_PHONES_MAX = 3;

/** Solo teléfonos físicos: ni accesorios, ni kits, ni SIM, ni servicios. */
export function phonesForSale<T extends CatalogItem>(items: readonly T[]): T[] {
    return items.filter((item) => item.category === 'PHONE' && !isService(item));
}

export function isLastPhones(item: Pick<CatalogItem, 'stock'>): boolean {
    const available = availableOf(item);
    return available > 0 && available <= LAST_PHONES_MAX;
}

export function isSellable(item: Pick<CatalogItem, 'stock'>): boolean {
    return availableOf(item) > 0;
}

/** Aviso cuando la lista de teléfonos no es el catálogo completo; `null` si lo es. */
export function catalogReadNotice(
    read: { truncated: boolean } | undefined,
    failedMidway: boolean,
): { title: string; body: string } | null {
    if (failedMidway) {
        return {
            title: 'No se pudo leer todo el catálogo.',
            body: 'La lista muestra solo los teléfonos que alcanzaron a llegar. Vuelve a cargar la pantalla para ver el resto.',
        };
    }
    if (read?.truncated === true) {
        return {
            title: 'El catálogo de tu tienda superó el tope de lectura.',
            body: 'La lista no tiene todos los teléfonos. Usa el buscador si no encuentras uno.',
        };
    }
    return null;
}
